import React from 'react';
import PropTypes from 'prop-types';

const DeveloperLink = ({ developerLink, addDevLink, handleClick }) => {
  return developerLink ? (
    <div
      className="details-developer-link"
      onClick={event => {
        addDevLink(event, developerLink.linkUrl, handleClick);
      }}
      onKeyDown={e =>
        e.keyCode === 13 &&
        addDevLink(event, developerLink.linkUrl, handleClick)
      }
      role="presentation"
    >
      <p
        className="align-left"
        dangerouslySetInnerHTML={{ __html: developerLink.linkText }}
      ></p>
    </div>
  ) : null;
};

DeveloperLink.propTypes = {
  developerLink: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  addDevLink: PropTypes.func,
  handleClick: PropTypes.func
};

export default DeveloperLink;
